import React from 'react';
import './StoryFestPage.css';
import HeroSection from './HeroSection';
import OverviewSection from './OverviewSection';
import ContactSection from './ContactSection';
import HomeBelievePage from './HomeBelievePage';
import PitchStoryPage from './PitchStoryPage';




const StoryFestPage = () => {
  return (
    <div className="storyfest-page-wrapper">
      
      
      <main>
        <HeroSection/>
        <OverviewSection/>
        <HomeBelievePage/>
         <PitchStoryPage/>
        <ContactSection/>
        
        
      </main>
      
    </div>
  );
};

export default StoryFestPage;